import React from 'react'
import { connect } from "react-redux";
import { Modal, Form, Button } from 'react-bootstrap'
import Select from 'react-select'
import DatePicker from "react-datepicker"
import { sendStaffAppMetaData } from "../staffApp/eventTriggers"
import withFetchHook from "../withFetchHook";
import Creatable from "react-select/lib/Creatable";

class VaccineFormModalC extends React.Component {
  kindOptions = [{ label: 'COVID-19', value: 'COVID-19' }, { label: 'Flu', value: 'Flu' }]
  setDefaultStaffAppMetaData = () => sendStaffAppMetaData(this.props.tabDefaultMetaData)

  updateVaccines(vaccine) {
    return this.props.fetch(`/organizations/${this.props.organizationName}/residents/${this.props.id}.json`, {
      method: "PATCH",
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        resident: { vaccines_attributes: [vaccine] }
      })
    })
  }

  saveVaccine = () => {
    return this.updateVaccines(this.props.vaccine).then((data) => {
      this.props.updateVaccines(data.vaccines)
      if (this.props.isStaffApp) {
        alert('Vaccine changes saved.')
        this.setDefaultStaffAppMetaData()
      }
      this.props.handleClose()
    })
  }

  deleteVaccine = () => {
    this.updateVaccines({
      id: this.props.vaccine.id,
      _destroy: true
    }).then((data) => {
      this.props.updateVaccines(data.vaccines)
    }).then(() => {
      if (this.props.isStaffApp) {
        alert('Vaccine successfully deleted.')
        this.setDefaultStaffAppMetaData()
      }
      this.props.handleClose()
    })
  }

  saveVaccineFunction = (e) => {
    this.props.dispatch(this.saveVaccine())
  }

  componentDidMount() {
    document.addEventListener('saveVaccine', this.saveVaccineDispatch)
  }

  componentWillUnmount() {
    document.removeEventListener('saveVaccine', this.saveVaccineDispatch)
  }

  render() {
    const { show, handleClose, isStaffApp, vaccine, action, updateField, hasDelete, hasEdit } = this.props
    const { kindOptions, saveVaccine, deleteVaccine } = this
    return (
      <Modal show={show} onHide={handleClose}>
        {
          !isStaffApp &&
          <Modal.Header closeButton>
            <Modal.Title>Vaccine</Modal.Title>
          </Modal.Header>
        }
        <Modal.Body className={hasEdit ? "" : "form-modal-width"}>
          {hasEdit ? (
            <>
              <Form.Group controlId="vaccineKind">
                <Form.Label>Kind</Form.Label>
                <Creatable
                 value={kindOptions.find(option => option.value == vaccine.kind)}
                 options={kindOptions}
                 onChange={(option) => updateField('kind', option.value)} />
              </Form.Group>

              <Form.Group controlId="vaccineReceivedOn">
                <Form.Label>Received On</Form.Label>
                <DatePicker
                  selected={vaccine.received_on ? moment(vaccine.received_on) : null}
                  className="form-control"
                  onChange={(date) => updateField('received_on', date ? date.format("YYYY-MM-DD") : null)} />
              </Form.Group>

              <Form.Group controlId="vaccineNotes">
                <Form.Label>Notes</Form.Label>
                <Form.Control
                  className="form-control"
                  value={vaccine.notes}
                  onChange={(e) => updateField('notes', e.target.value)} />
              </Form.Group>
            </>
          ) : (
            <>
              <Form.Group>
                <Form.Label>Kind</Form.Label>
                <div className="form-control-plaintext">{vaccine.kind || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Received On</Form.Label>
                <div className="form-control-plaintext">{vaccine.received_on ? moment(vaccine.received_on).format('MM/DD/YYYY') : 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Notes</Form.Label>
                <div className="form-control-plaintext">{vaccine.notes || 'N/A'}</div>
              </Form.Group>
            </>
          )}



          {
            !isStaffApp ?
              <Modal.Footer>
                {
                  action === "edit" && hasDelete &&
                  <Button
                    variant="outline-danger"
                    onClick={() => deleteVaccine(vaccine)}>
                    Delete
                  </Button>
                }
                <Button
                  variant="info"
                  onClick={() => {
                    saveVaccine(vaccine)
                  }}>
                  {action === "edit" ? "Update" : "Create"}
                </Button>
              </Modal.Footer> :
              <>
                {
                  action === 'edit' && hasDelete &&
                  <div className="p-3">
                    <Button
                      onClick={() => deleteVaccine(vaccine)}
                      className="w-100"
                      variant="outline-danger">
                      Delete
                    </Button>
                  </div>
                }
              </>
          }
        </Modal.Body>
      </Modal>
    )
  }
}


const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.vaccineModal.show,
    action: state.ui.action,
    isStaffApp: state.config.isStaffApp,
    vaccine: state.ui.vaccineModal.vaccine,
    organizationName: state.organization.name,
    id: state.resident.id,
    tabDefaultMetaData: state.config.tab_default_meta_data.find(tab => tab.detail == 'vaccines'),
    hasDelete: state.current_user.permissions.includes('Delete'),
    hasEdit: state.current_user.permissions.includes('Edit')
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleClose: () => dispatch({ type: 'CLOSE_VACCINE_FORM_MODAL' }),
    updateField: (name, value) => dispatch({ type: "UPDATE_VACCINE_FIELD", payload: { name, value } }),
    updateVaccines: (vaccines) => dispatch({ type: "UPDATE_VACCINES", payload: { vaccines } }),
    dispatch: (func) => dispatch(func()),
  }
}

export const VaccineFormModal = withFetchHook(connect(mapStateToProps, mapDispatchToProps)(VaccineFormModalC));
